import React from 'react';
import classnames from 'classnames';
import DynamicLink from '../DynamicLink';
import * as styles from './GlobalNav.module.styl';
import getHelpFileURL from '../../utils/getHelpFileURL';

const IntegrationItem = ({ integration, isMobile = false }) => {
  if (!(integration?.title && integration?.link_url && integration?.image))
    return null;

  return (
    <DynamicLink link={integration.link_url} activeClassName={styles.active}>
      <div
        className={classnames(
          styles.subMenuIntegration,
          isMobile && styles.subMenuIntegrationMobile,
        )}
      >
        <div className={styles.subMenuIntegrationImage}>
          <img
            src={getHelpFileURL(integration.image)}
            alt={integration.title}
          />
        </div>
        {integration.title}
      </div>
    </DynamicLink>
  );
};

export default IntegrationItem;
